import { createContext } from 'react';

import { type FEATURE_FLAG_KEY } from './checkFeatureFlag';

type Data = {
  creatorId?: string;
};

export type FeatureFlagsContextType = {
  checkFeatureFlag: (featureFlag: FEATURE_FLAG_KEY, data?: Data) => boolean;
};

const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
  checkFeatureFlag: () => false,
});

export default FeatureFlagsContext;
